exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-image.v-responsive.theme--light[data-v-7d08a692]{border-bottom:1px solid #126184}", ""]);

// exports
